// App.jsx
import { Fragment, useEffect, useRef } from "react";
import { EntypoSprite } from "@entypo-icons/react";
import { Routes, Route } from "react-router-dom";
import routes from "@/routes.jsx";
import Layouts from "@/layouts/Layouts.jsx";
import { DashboardDataProvider } from "@/context/dashboardDataContext.jsx";
import OAuthCallback from "@/features/auth/pages/OAuthCallback.jsx";
import NotFound from "./views/NotFound";
import ForbiddenPage from "./views/ForbiddenPage";

const CALLBACK_URL = import.meta.env.VITE_CALLBACK_URL;

function App() {

    return (
        <div className="admin-container position-relative overflow-hidden">
            <DashboardDataProvider>
                <EntypoSprite />
                <Routes>
                    {routes?.map((item, index) => {
                        return (
                            <Fragment key={index}>
                                {(item?.path && (
                                    <Route
                                        path="/"
                                        element={
                                            <Layouts />
                                        }
                                    >
                                        <Route
                                            path={item?.path}
                                            element={<item.component />}
                                        />
                                    </Route>
                                )) ||
                                    (item?.route && (
                                        <Route
                                            path={item?.route}
                                            element={<item.component />}
                                        />
                                    ))}
                            </Fragment>
                        );
                    })}

                    <Route path="*" element={<NotFound />} />

                    <Route path={CALLBACK_URL} element={<OAuthCallback />} />
                    <Route path="403" element={<ForbiddenPage />} />
                </Routes>
            </DashboardDataProvider>
        </div>
    );
}

export default App;

